import React, { useState, useEffect } from "react";
import { Button, FormGroup, Label, Input } from "reactstrap";
import Play from "../../../assets/images/verboden/play.png";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as game3Action from "../../../redux/game3/actions";
import * as loaderAction from "../../../redux/loader/action";
import * as paramsAction from "../../../redux/gameParams/actions";
import Alert from "../../../components/shared/common/alert";
import _ from "lodash";
import Socket from "../../../socket/socket";
import sfw_switch_circle from "../../../assets/images/CHPT/sfw-switch.png";

const Timer = (props) => {
  const roomData = props.gameReducer.roomObj;
  const time = _.get(roomData, "lobby_parameters.timer", 60);
  useEffect(() => {
    setTimer(time);
  }, [time]);
  const [timer, setTimer] = useState(time);
  const [isDoubleRounds, setDoubleRounds] = useState(false);
  const isDoubleRoundsForMapp = _.get(
    roomData,
    "lobby_parameters.double_rounds",
    false
  );

  const doubleRoundsLabel = _.get(
    props,
    "paramsReducer.gameObj.screens.lobby.double_rounds_label",
    "Double Rounds"
  );

  const status = _.get(roomData, "game_state.status");
  const onStartGame = () => {
    const roomData = props.gameReducer.roomObj;
    const teams = roomData.game_state.teams;
    if (roomData && roomData.users && roomData.users.length < 4) {
      Alert(400, "Need at least 4 players to start the game");
      return;
    } else {
      if (
        (teams[0].team_queue.length < 2 && teams[1].team_queue.length >= 3) ||
        (teams[1].team_queue.length < 2 && teams[0].team_queue.length >= 3)
      ) {
        Alert(400, "Need at least 2 players to start the game");
        return;
      }
    }
    let obj = {
      action: "update-status",
      roomId: roomData.id,
      // tableTopName: props.gameReducer.allGames[2].title,
      tableTopName: "Verboden",
      timer: timer,
      doubleRounds: isDoubleRounds
    };
    // props.history.push({
    //   pathname: "/verboden/play",
    //   state: { timer: timer },
    // });

    props.on_start_game();
    props.setTimerOfGame(timer);
    Socket.sendMessage(obj);
  };

  const onChange = (time) => {
    setTimer(time);
  };
  let TimeRanges = [60, 90, 120];
  let button_text = "START GAME";
  if (props.paramsReducer && props.paramsReducer.gameObj) {
    let gameObj = props.paramsReducer.gameObj;

    if (gameObj && gameObj.screens && gameObj.screens.lobby) {
      button_text = gameObj.screens.lobby.button_text;
      let timer1 = gameObj.screens.lobby.timer_1;
      let timer2 = gameObj.screens.lobby.timer_2;
      let timer3 = gameObj.screens.lobby.timer_3;
      TimeRanges = [parseInt(timer1), parseInt(timer2), parseInt(timer3)];
    }
  }
  useEffect(() => {
    let data = {
      action: "update-lobby-options",
      roomId: roomData.id,
      double_rounds: isDoubleRounds
    };
    Socket.sendMessage(data);
  }, [isDoubleRounds]);

  useEffect(() => {
    let data = {
      action: "update-lobby-options",
      roomId: roomData.id,
      timer: timer
    };
    Socket.sendMessage(data);
  }, [timer]);

  useEffect(() => {
    return Socket.addListener("update-status", async (res) => {
      props.setTimerOfGame(res.timer);
      console.log(res, "resresresresresresresresresresres");
      props.history.push("/verboden/play");
    });
  }, []);
  let gameObj = props.gameReducer;

  let time1 = gameObj.roomObj.lobby_parameters.timer;

  useEffect(() => {
    if (status != "Joining") {
      let gameObj = props.gameReducer;
      let time = _.get(gameObj, "roomObj.game_state.game_parameters.timer");
      console.log(time, "RDU3WRDU3W");
      let dataObj = {
        gameName:
          gameObj.gameName !== "" ? gameObj.gameName : gameObj.roomObj.game_code
      };
      props.getGameData(dataObj);
      if (Object.keys(props.paramsReducer.gameObj).length > 0) {
        props.setTimerOfGame(time);
        props.history.push("/verboden/play");
      }
    }
  }, [status, props.paramsReducer.gameObj]);

  return (
    <div className="timer-wrapper">
      <div className="d-flex">
        <div className="timer timer-col">
          <div>
            <h2 className="text-white mb-0">Timer</h2>
            <div className="timer-radioBtn">
              {TimeRanges.map((time, index) => (
                <FormGroup check key={index}>
                  <Label check className="text">
                    <Input
                      type="radio"
                      name="radio2"
                      checked={timer === time}
                      onChange={() => onChange(time)}
                    />{" "}
                    <span className="radioBtn"></span>
                    {time}
                  </Label>
                </FormGroup>
              ))}
            </div>
          </div>
          <div className="tot-toggle-wrapper">
            <h4 className="text-white">{doubleRoundsLabel}</h4>
            <div className="verbodden-toggle">
              <label className="switch">
                {/* <button onClick={() => setDoubleRounds(!isDoubleRounds)} /> */}
                {isDoubleRoundsForMapp ? (
                  <label
                    className="on-verboden"
                    onClick={() => setDoubleRounds(!isDoubleRounds)}
                  >
                    <img
                      src={sfw_switch_circle}
                      className="on-circle"
                      alt="plus"
                    />
                  </label>
                ) : (
                  <span
                    className="off-verboden"
                    onClick={() => setDoubleRounds(!isDoubleRounds)}
                  >
                    <img
                      src={sfw_switch_circle}
                      className="off-circle"
                      alt="plus"
                    />
                  </span>
                )}
              </label>
            </div>
          </div>
        </div>
        <div className="play-btn timer-col">
          <Button onClick={() => onStartGame()} color="themeGreen">
            {button_text}
            <img src={Play} className="mr-2" />
          </Button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    setTimerOfGame: (data) => dispatch(game3Action.setTimerOfGame(data)),
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
    getGameData: (data) => dispatch(paramsAction.getGameData(data))
  };
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Timer);
